module.exports = __webpack_public_path__ + "static/media/ms.527a9934.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ms.svg
// module id = 2162
// module chunks = 0